import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends DatabaseGwService{

  URL_PATH: string = "/companies";

  getAllConfig() {
    return this.query({}, '/company-setting');
  }

  getAllBranch(filter:any={}){
    return this.query(filter, '/branch');
  }
}
